import React, { useEffect, useState } from "react";
import "./Add_offcanvas.css";
import Select from "react-select";
import { Button, Form, Offcanvas } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Blue_btn from "../../../../../../common_components/common_btn/blue_btn/Blue_btn";
import Blue_border_button from "../../../../../../common_components/common_btn/blue_border_button/Blue_border_button";
import Success_modal from "../../../../../../common_components/common_modal/success_modal/Success_modal";
import successAnimation from "../../../../../../animation/success_lottie/Success_lottie.json";
import classNames from "classnames";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import {
  Create,
  GetAll,
} from "../../../../../../../features/admin/role_permmission/role/Slice";
import { AllPermmission } from "../../../../../../../features/admin/common/Slice";

function Add_offcanvas({
  setShow,
  setSuccess,
  setErr,
  setShowError,
  defaultValues,
  showError,
  show,
  handleClose,
  setShowRejectModal,
}) {
  const {
    register,
    handleSubmit,
    reset,
    setValue,
    getValues,
    formState: { errors },
  } = useForm({ defaultValues });
  const dispatch = useDispatch();
  const permissions = useSelector((state) => state.common.all_permission);

  // Fetch all permissions once
  useEffect(() => {
    dispatch(AllPermmission());
  }, [dispatch]);

  const [modalSuccessShow, setModalsuccessShow] = useState(false);
  const [selectedPermissions, setSelectedPermissions] = useState([]);

  const onSubmit = async (data) => {
    try {
      const res = await dispatch(Create(data));

      // Check if the request was successful
      if (res.meta?.requestStatus === "fulfilled") {
        dispatch(GetAll());
        setShow(false);
        setSuccess(true);
      } else if (res.meta?.requestStatus === "rejected") {
        setShowError(res.payload?.response?.data?.errors);
      }
    } catch (error) {
      setShow(false);
      setErr(true);
      console.error(error);
    }
  };

  const handleCheckboxChange = (permissionId, value = null, checked = null) => {
    if (value === "selectAll") {
      if (checked) {
        const allIds = permissions.map((p) => p.id);
        setSelectedPermissions(allIds);
        setValue("permission_id", allIds);
      } else {
        setSelectedPermissions([]);
        setValue("permission_id", []);
      }
    } else {
      const currentPermissions = getValues("permission_id") || [];
      const updated = currentPermissions?.includes(permissionId)
        ? currentPermissions?.filter((id) => id !== permissionId)
        : [...currentPermissions, permissionId];

      setSelectedPermissions(updated);
      setValue("permission_id", updated);
    }
  };

  return (
    <>
      <Offcanvas
        show={show}
        onHide={handleClose}
        placement="end"
        className="view_application_canvas common_offcanvas"
      >
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>Add</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <div className="form_holder">
            <Form onSubmit={handleSubmit(onSubmit)}>
              <div className="row">
                {/* Full Name */}
                <div className="col-md-4 mb-3">
                  <Form.Group className="form_field">
                    <Form.Label>Name</Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Enter Name"
                      className={classNames("", { "is-invalid": errors?.name })}
                      {...register("name", {
                        required: "Name is required",
                        maxLength: {
                          value: 100,
                          message: "Name cannot exceed 100 characters",
                        },
                        pattern: {
                          value: /^[A-Za-z]+(?:\s[A-Za-z]+)*$/,
                          message:
                            "Name should contain only letters and single spaces (no leading or trailing spaces)",
                        },
                      })}
                    />
                    {errors?.name && (
                      <Form.Text className="text-danger">
                        {errors?.name?.message}
                      </Form.Text>
                    )}
                    {showError && (
                      <Form.Text className="text-danger">{showError}</Form.Text>
                    )}
                  </Form.Group>
                </div>

                <div className="col-md-6">
                  <Form.Group className="mb-3">
                    <Form.Check
                      label="Permissions Select All"
                      type="checkbox"
                      checked={
                        permissions?.length > 0 &&
                        selectedPermissions?.length === permissions.length
                      }
                      onChange={(e) =>
                        handleCheckboxChange(
                          null,
                          "selectAll",
                          e.target.checked
                        )
                      }
                    />
                  </Form.Group>
                </div>

                <div className="option_select_holder mb-4">
                  <div className="row">
                    {Array.isArray(permissions) &&
                      permissions?.map((data) => (
                        <div className="col-md-3" key={data.id}>
                          <Form.Group>
                            <Form.Check
                              type="checkbox"
                              label={data.name}
                              id={`checkbox-${data.id}`}
                              checked={selectedPermissions?.includes(data.id)}
                              onChange={() => handleCheckboxChange(data.id)}
                            />
                          </Form.Group>
                        </div>
                      ))}
                  </div>
                  {errors.permission_id && (
                    <Form.Text className="text-danger">
                      {errors.permission_id.message}
                    </Form.Text>
                  )}
                </div>
              </div>

              <div className="btn_holder">
                {/* <Blue_btn btn_text={"Cancle"} /> */}
                <Blue_border_button button_text={"Save"} type="submit" />
              </div>
            </Form>
          </div>
        </Offcanvas.Body>
      </Offcanvas>

      <Success_modal
        show={modalSuccessShow}
        onHide={() => setModalsuccessShow(false)}
        message_text={"Operation was successful!"}
        animationData={successAnimation}
      />
    </>
  );
}

export default Add_offcanvas;
